import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement } from 'rax';
import Text from 'rax-text';
import View from '../../view';
import { isString } from '../../utils';
const ListItemCaption = (props) => {
    const { prefix = 'mt-', children, className } = props, others = __rest(props, ["prefix", "children", "className"]);
    const newClassName = classNames(`${prefix}list-item-caption`, className);
    return isString(children) ? (<Text {...others} className={newClassName}>
      {children}
    </Text>) : (<View {...others} className={newClassName}>
      {children}
    </View>);
};
export default ListItemCaption;
